/* src/app/master-data/branches/list-branch/list-branch.component.css */
/*# sourceMappingURL=list-branch.component-IK2UAMIW.css.map */
